<template>
    <Dropdown class="docs-dropdown" title="Документы">
        <template #label>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
                <path
                    d="M441.239 137.656L306.547 2.964A10.118 10.118 0 00299.391 0H109.598c-23.049 0-41.8 18.751-41.8 41.8v428.4c0 23.049 18.751 41.8 41.8 41.8h292.804c23.049 0 41.8-18.751 41.8-41.8V144.811a10.12 10.12 0 00-2.963-7.155zM309.511 34.549L409.654 134.69h-78.582c-11.889 0-21.56-9.672-21.56-21.562V34.549zM423.964 470.2c0 11.889-9.672 21.562-21.562 21.562H109.598c-11.889 0-21.562-9.673-21.562-21.562V41.8c0-11.889 9.673-21.562 21.562-21.562h179.674v92.892c0 23.049 18.75 41.8 41.799 41.8h92.893V470.2z"
                    fill="#666882"
                />
                <path
                    d="M336.949 257.012H175.051c-5.588 0-10.119 4.531-10.119 10.119s4.531 10.119 10.119 10.119h161.898c5.59 0 10.119-4.531 10.119-10.119s-4.529-10.119-10.119-10.119zM336.949 302.208H175.051c-5.588 0-10.119 4.531-10.119 10.119s4.531 10.119 10.119 10.119h161.898c5.59 0 10.119-4.531 10.119-10.119s-4.529-10.119-10.119-10.119zM336.949 347.404H175.051c-5.588 0-10.119 4.531-10.119 10.119s4.531 10.119 10.119 10.119h161.898c5.59 0 10.119-4.531 10.119-10.119s-4.529-10.119-10.119-10.119zM284.332 392.601H175.051c-5.588 0-10.119 4.531-10.119 10.119s4.531 10.119 10.119 10.119h109.281c5.59 0 10.119-4.531 10.119-10.119s-4.529-10.119-10.119-10.119z"
                    fill="#666882"
                />
            </svg>
        </template>
        <template #items>
            <router-link v-slot="{ navigate }" custom to="/docs/getting-started/">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('docsDropdown.tutorial') }}
                </li>
            </router-link>
            <router-link v-slot="{ navigate }" custom to="/docs/agreement/">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('docsDropdown.terms') }}
                </li>
            </router-link>
            <router-link v-slot="{ navigate }" custom to="/plans">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('payment.plans.title') }}
                </li>
            </router-link>
            <router-link v-slot="{ navigate }" custom to="/docs/rule/">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('docsDropdown.rules') }}
                </li>
            </router-link>
            <router-link v-slot="{ navigate }" custom to="/docs/payment/">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('docsDropdown.payment') }}
                </li>
            </router-link>
            <router-link v-slot="{ navigate }" custom to="/docs/prepare/">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('docsDropdown.prepareBook') }}
                </li>
            </router-link>
            <router-link v-slot="{ navigate }" custom to="/contract/documents/">
                <li class="dropdown__item dropdown__item--link" @click="navigate">
                    {{ $t('docsDropdown.contracts') }}
                </li>
            </router-link>
            <router-link v-slot="{ navigate }" custom to="/faq">
                <li class="dropdown__item dropdown__item--link" @click="navigate">FAQ</li>
            </router-link>
        </template>
    </Dropdown>
</template>

<script>
// @TODO maybe shared this isn't the place for do
import Dropdown from '@speechki-frontend/shared/ui/Dropdown';

export default {
    name: 'DocsDropdown',
    components: {
        Dropdown,
    },
};
</script>

<style lang="scss" src="./DocsDropdown.scss"></style>
